import { faMagnifyingGlass } from "@fortawesome/pro-solid-svg-icons";
import { polymorphicComponentWrapper } from "../../utilities";
import type {
    CustomSearchInputFactory,
    CustomSearchInputFormikFactory,
    IProps,
    ISearchInputFormikProps,
} from "./search-input.types";
import { Input } from "../input";
import { Icon } from "../icon";

/**
 * Search input component with a built-in search icon.
 * @returns {JSX.Element} The SearchInput component.
 */
const SearchInput = polymorphicComponentWrapper<CustomSearchInputFactory, IProps>("SearchInput", (props, ref) => {
    return <Input ref={ref} placeholder={"Search..."} leftSection={<Icon icon={faMagnifyingGlass} />} {...props} />;
});

/**
 * Search input component integrated with Formik for form handling and validation.
 * @param {string} props.name - The name of the search input field for Formik.
 * @param {function} props.validate - Custom validation function for the field.
 * @returns {JSX.Element} The SearchInputFormik component.
 */
const SearchInputFormik = polymorphicComponentWrapper<CustomSearchInputFormikFactory, ISearchInputFormikProps>(
    "SearchInputFormik",
    (props, ref) => {
        return (
            <Input.Formik
                ref={ref}
                placeholder={"Search..."}
                leftSection={<Icon icon={faMagnifyingGlass} />}
                {...props}
            />
        );
    }
);

SearchInput.Formik = SearchInputFormik;

export { SearchInput, SearchInputFormik };
